export const getProductAssetsDomain = (urlSlug: String): String => `https://cartridgesave.co.uk/media/catalog/product${urlSlug.startsWith('/') ? '' : '/'}${urlSlug}`;
